import RequestManager from "../../../requests/RequestManager";
import LiveMatchActionsTask from "../../../requests/tasks/sports/liveMatchActionsTask";
import logger from 'src/utils/logger/logger';

export const getLiveMatchActions = async (matchId, options = {}) => {
    try {
        const liveMatchActionsTask = new LiveMatchActionsTask(matchId, options);
        const response = await RequestManager.addRequest(liveMatchActionsTask);
        if (!response) return { events: [], lastEventId: null, hasMore: false, nextPollMs: 60000 };
        return response.response || response;
    } catch (error) {
        logger.error('Error getting live match actions:', error);
        return { events: [], lastEventId: null, hasMore: false, nextPollMs: 60000 };
    }
};



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getLiveMatchActions.js